import WJSON from '../libs/wjson';

const UPDATE_USER_INFO  = "UPDATE_USER_INFO";
const CLEAN_USER_INFO   = "CLEAN_USER_INFO";

// dispatch function
export const updateUserInfo        = (newState) => ({ type : UPDATE_USER_INFO, newState })
export const cleanUserInfo         = (newState) => ({ type : CLEAN_USER_INFO, newState })

const defaultUserInfo = {
  addresses: null,
  agree_receive_sms: null,
  amt_balance: null,
  birthday: null,
  checkSum: null,
  cn_name: null,
  email: null,
  employee_flag: null,
  en_name: null,
  flag: null,
  gender: null,
  gid: null,
  home_phone: null,
  mobile: null,
  point_balance: null,
  reg_dt: null,
  twid: null,
  vip_flag: null,
  work_phone: null,
}

// reducer
export default (state = {}, action) => {
  
  let user = WJSON.decode(localStorage.getItem('wuser')) || defaultUserInfo
  
  user = {...defaultUserInfo, ...user, ...state}
  
  if (action.type === UPDATE_USER_INFO)
  {
    
    user = { ...user, ...action.newState }
    //console.log("user", user)
    // user.isLogin = (user.access_token !== null && (typeof user.access_token === 'string') && user.access_token.length > 0)

    localStorage.setItem('wuser', WJSON.encode(user))

    return user
  }

  if (action.type === CLEAN_USER_INFO )
  {
    localStorage.setItem('wuser', WJSON.encode(defaultUserInfo))

    return defaultUserInfo
  }
  
  return user
}


// WEBPACK FOOTER //
// ./src/reducers/user.js